import React, { useState } from "react";
import { FaShieldAlt, FaExchangeAlt, FaCogs, FaLock, FaMinus, FaPlus, FaChartLine, FaBalanceScale, FaNetworkWired, FaChartPie, FaBrain, FaHeadset, FaExpandArrowsAlt, FaExclamationTriangle, FaFileCode, FaCloud, FaSync, FaDatabase, FaCode, FaHospital, FaDesktop, FaArrowsAlt, FaBriefcaseMedical, FaDollarSign} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const Lis = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">LIS Data Integration Solutions</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs,We specialize in seamless LIS integrations, ensuring laboratories, hospitals, and clinics can efficiently exchange data with EHR systems, diagnostic tools, and healthcare applications. Our solutions improve workflow automation, data accuracy, and interoperability, empowering healthcare providers with real-time insights.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>


                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Automated Data Exchange",
        description: "Ensure seamless interoperability between Laboratory Information Systems (LIS) and other healthcare platforms.",
        icon: FaExchangeAlt
    },
    {
        title: "Standardized Protocols",
        description: "Implement HL7, FHIR, and LOINC standards to maintain consistent and structured data exchange.",
        icon: FaFileCode
    },
    {
        title: "Error Reduction",
        description: "Minimize manual data entry errors by automating integration workflows and data synchronization.",
        icon: FaExclamationTriangle
    },
    {
        title: "Real-Time Reporting",
        description: "Enable instant access to lab results, accelerating clinical decision-making and improving patient care.",
        icon: FaChartLine
    },
    {
        title: "Secure & Compliant Solutions",
        description: "Ensure full compliance with HIPAA, CLIA, and CAP regulations to maintain data security and privacy.",
        icon: FaShieldAlt
    },
    {
        title: "Scalable Infrastructure",
        description: "Support high-volume data processing and adapt to the growing needs of healthcare organizations.",
        icon: FaExpandArrowsAlt
    },
    {
        title: "Multi-System Integration",
        description: "Seamlessly connect LIS with EHRs, pharmacy systems, and imaging platforms for comprehensive healthcare interoperability.",
        icon: FaNetworkWired
    },
    {
        title: "Customizable Workflows",
        description: "Adapt integration workflows to match unique laboratory processes and operational requirements.",
        icon: FaCogs
    },
    {
        title: "AI-Driven Insights",
        description: "Utilize artificial intelligence to detect patterns, optimize workflows, and enhance decision-making.",
        icon: FaBrain
    },
    {
        title: "24/7 Monitoring & Support",
        description: "Ensure continuous system performance with proactive monitoring, maintenance, and real-time technical support.",
        icon: FaHeadset
    },
    {
        title: "Seamless Cloud Integration",
        description: "Enable cloud-based LIS integration for enhanced accessibility, scalability, and data backup.",
        icon: FaCloud
    },
    {
        title: "Enhanced Data Visualization",
        description: "Provide interactive dashboards and graphical reports for better analysis of lab data and trends.",
        icon: FaChartPie
    }
];


const services = [

    {
        title: "LIS & EHR Integration",
        description: "Enable direct communication between laboratory and hospital systems for seamless data exchange.",
        icon: FaHospital
    },
    {
        title: "Custom API Development",
        description: "Create tailored APIs to facilitate secure and efficient LIS data exchange.",
        icon: FaCode
    },
    {
        title: "Data Standardization",
        description: "Convert lab data into structured formats such as HL7, FHIR, and DICOM for interoperability.",
        icon: FaDatabase
    },
    {
        title: "Automated Workflow Solutions",
        description: "Reduce manual intervention with automation for order entry, sample tracking, and result processing.",
        icon: FaCogs
    },
    {
        title: "Lab Test Result Synchronization",
        description: "Ensure accurate and rapid transmission of lab test results between systems.",
        icon: FaSync
    },
    {
        title: "Multi-System Compatibility",
        description: "Integrate seamlessly with hospitals, clinics, research labs, and diagnostic centers.",
        icon: FaNetworkWired
    },
    {
        title: "Real-Time Monitoring & Support",
        description: "Provide continuous system tracking, issue resolution, and performance optimization.",
        icon: FaHeadset
    },
    {
        title: "Secure Data Exchange",
        description: "Implement encryption and access controls to safeguard sensitive lab and patient data.",
        icon: FaLock
    },
    {
        title: "AI-Powered Diagnostics",
        description: "Enhance lab efficiency with AI-driven analytics for result interpretation and anomaly detection.",
        icon: FaBrain
    },
    {
        title: "Cloud-Based Integration",
        description: "Enable cloud compatibility for remote access, backup, and data synchronization across locations.",
        icon: FaCloud
    }
];
const whyChooseUs = [
    {
        title: "Industry Expertise",
        description: "Extensive experience in LIS and EHR integrations, ensuring reliable and efficient solutions.",
        icon: FaBriefcaseMedical
    },
    {
        title: "Scalability & Flexibility",
        description: "Our systems grow with your laboratory, adapting to evolving healthcare needs.",
        icon: FaArrowsAlt
    },
    {
        title: "End-to-End Security",
        description: "Advanced encryption, multi-layer authentication, and access controls safeguard patient data.",
        icon: FaLock
    },
    {
        title: "Seamless Data Flow",
        description: "Real-time synchronization for faster test result turnaround and improved patient care.",
        icon: FaExchangeAlt
    },
    {
        title: "Regulatory Compliance",
        description: "Adherence to CLIA, HIPAA, CAP, and FDA guidelines for hassle-free compliance.",
        icon: FaBalanceScale
    },
    {
        title: "User-Friendly Dashboards",
        description: "Intuitive interfaces designed for lab technicians and healthcare professionals to streamline operations.",
        icon: FaDesktop
    },
    {
        title: "24/7 Support & Monitoring",
        description: "Dedicated support team providing real-time assistance and system monitoring to ensure smooth operations.",
        icon: FaHeadset
    },
    {
        title: "Cost-Effective Solutions",
        description: "Optimized workflows and automation to reduce operational costs without compromising quality.",
        icon: FaDollarSign
    }
];

const List = [
    
        {
            "title": "Laboratory Data Interoperability",
            "description": "Enable seamless, secure, and standardized data exchange between laboratories, hospitals, and healthcare providers. Our interoperability solutions ensure accurate and efficient lab result sharing, improving diagnostic workflows and patient care. Automated processes enhance operational efficiency while maintaining compliance with HL7 and FHIR standards.",
            "icon": "FaExchangeAlt"
        },
        {
            "title": "Electronic Order Management",
            "description": "Optimize the entire lab order lifecycle with automated order entry, tracking, and results retrieval. Reduce manual errors, accelerate turnaround times, and ensure real-time communication between healthcare providers and laboratories. Our solution enhances accuracy, improves efficiency, and integrates seamlessly with existing healthcare systems.",
            "icon": "FaFileMedical"
        },
        {
            "title": "Bi-Directional LIS Integration",
            "description": "Facilitate real-time, two-way communication between Laboratory Information Systems (LIS), Electronic Health Records (EHR), and Picture Archiving and Communication Systems (PACS). Our integration framework ensures synchronized data exchange, reducing redundancy and improving patient outcomes through timely and accurate information sharing.",
            "icon": "FaSyncAlt"
        },
        {
            "title": "Quality Control & Reporting",
            "description": "Leverage AI-driven analytics and automated quality control measures to ensure the accuracy, reliability, and compliance of laboratory data. Generate comprehensive reports for audits, performance tracking, and clinical decision-making, ensuring laboratories meet regulatory standards and operational excellence.",
            "icon": "FaClipboardCheck"
        },
        {
            "title": "Custom Data Mapping & Transformation",
            "description": "Convert and standardize diverse data formats, including HL7, FHIR, and DICOM, for seamless interoperability across healthcare platforms. Our advanced data mapping solutions eliminate inconsistencies, ensuring accurate data flow between LIS, EHR, and third-party healthcare systems while maintaining regulatory compliance.",
            "icon": "FaProjectDiagram"
        },
        {
            "title": "Advanced Support & Maintenance",
            "description": "Ensure continuous system reliability with 24/7 monitoring, regular software updates, and proactive issue resolution. Our dedicated support team helps minimize downtime, enhance system performance, and maintain compliance with healthcare industry regulations, ensuring smooth and uninterrupted operations.",
            "icon": "FaHeadset"
        }
    ]
    



export default Lis;
